import React, { useState, useEffect } from "react";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import Loader from "react-loader-spinner";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router";
import { Col, Form, Row, Button } from "react-bootstrap";
import Switch from "react-switch";
import {
  TextField,
  FormControl,
  Select,
  InputLabel,
  makeStyles,
  MenuItem,
} from "@material-ui/core";
import Alert from "react-s-alert";
import { useFormik } from "formik";
import * as yup from "yup";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import {
  admin_add_uom_ratio,
  admin_update_uom_ratio,
  admin_get_all_ratio_conversation,
} from "../../../../store/actions/SuperAdminActions/superAdminUOMAction";

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const SuperAdminAddUomRatio = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const editUom = location.state;

  const formik = useFormik({
    initialValues: {
      major_classification: "",
      conversion_from_id: "",
      conversion_to_id: "",
      conversion_from_short_code: "",
      conversion_to_short_code: "",
      conversion_from_value: 0,
      conversion_to_value: 0,
      status: true,
    },
    validationSchema: yup.object({
      major_classification: yup
        .string()
        .required("Major classification is required"),
      conversion_from_short_code: yup
        .string()
        .required("Conversation From is required"),
      conversion_to_short_code: yup
        .string()
        .required("Conversation To is required")
        .notOneOf(
          [yup.ref("conversion_from_short_code"), null],
          "Conversation To can not be same as Conversation From"
        ),
      conversion_from_value: yup
        .number()
        .required("Conversation From value is required")
        .min(1, "Min 1 characters*"),
      conversion_to_value: yup
        .number()
        .required("Conversation To value is required")
        .min(1, "Min 1 characters*"),
    }),
    onSubmit: (values) => {
      let token = props.auth.user.accessToken;
      let editId = editUom?.editState?._id;
      let formData = {
        major_classification: values.major_classification,
        conversion_from_id: values.conversion_from_id,
        conversion_to_id: values.conversion_to_id,
        conversion_from_short_code: values.conversion_from_short_code,
        conversion_to_short_code: values.conversion_to_short_code,
        conversion_from_value: values.conversion_from_value,
        conversion_to_value: values.conversion_to_value,
        status: values.status ? "ACTIVE" : "INACTIVE",
      };
      if (
        formData?.conversion_from_id == formData?.conversion_to_id ||
        formData?.conversion_from_short_code ==
          formData?.conversion_to_short_code
      ) {
        Alert.error(`<h4>Conversion can not be same</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 5000,
          offset: 35,
        });
      } else {
        if (editUom?.editAction) {
          dispatch(
            admin_update_uom_ratio(token, formData, editId, onEditSuccessRatio)
          );
        } else {
          dispatch(admin_add_uom_ratio(token, formData, onSuccessAddRatio));
        }
      }

      // else if (
      //   formData?.conversion_from_value == formData?.conversion_to_value
      // ) {
      //   Alert.error(`<h4>Conversion ratio can not be same</h4>`, {
      //     position: "top-right",
      //     effect: "bouncyflip",
      //     beep: true,
      //     html: true,
      //     timeout: 5000,
      //     offset: 35,
      //   });
      // }
    },
  });

  const onSuccessAddRatio = () => {
    formik.resetForm();
    Alert.success(`<h4>Ratio Add Successfully</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 5000,
      offset: 35,
    });
  };

  const onEditSuccessRatio = () => {
    formik.resetForm();
    history.push("/superadmin/management-services/uom-ratio");
    Alert.success(`<h4>Records updated succesfully</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 5000,
      offset: 35,
    });
  };

  const [count, setCount] = useState(1);
  const onClickSave = (e) => {
    e.preventDefault();
    setCount(count + 1);
    formik.handleSubmit();
  };

  /********************************
   * @DESC Conversion Action
   ********************************/
  useEffect(() => {
    let majorClassification = props?.conversationData;
    for (let i = 0; i < majorClassification.length; i++) {
      if (
        majorClassification[i]?.short_code ==
        formik.values?.conversion_from_short_code
      ) {
        formik.setFieldValue("conversion_from_id", majorClassification[i]?._id);
        break;
      }
    }
  }, [formik.values?.conversion_from_short_code]);

  useEffect(() => {
    let majorClassification = props?.conversationData;
    for (let i = 0; i < majorClassification.length; i++) {
      if (
        majorClassification[i]?.short_code ==
        formik.values?.conversion_to_short_code
      ) {
        formik.setFieldValue("conversion_to_id", majorClassification[i]?._id);
        break;
      }
    }
  }, [formik.values?.conversion_to_short_code]);

  /********************************
   * @DESC Status Action
   ********************************/
  const onChangeStatus = () => {
    formik.setFieldValue("status", !formik.values?.status);
  };

  useEffect(() => {
    let token = props.auth.user.accessToken;
    let majorClassification = formik.values?.major_classification;
    dispatch(admin_get_all_ratio_conversation(token, 1, majorClassification));
  }, [formik.values.major_classification]);

  useEffect(() => {
    if (editUom) {
      formik.setFieldValue(
        "major_classification",
        editUom?.editState?.major_classification
      );
      formik.setFieldValue(
        "conversion_from_id",
        editUom?.editState?.conversion_from_id
      );
      formik.setFieldValue(
        "conversion_to_id",
        editUom?.editState?.conversion_to_id
      );
      formik.setFieldValue(
        "conversion_from_short_code",
        editUom?.editState?.conversion_from_short_code
      );
      formik.setFieldValue(
        "conversion_to_short_code",
        editUom?.editState?.conversion_to_short_code
      );
      formik.setFieldValue(
        "conversion_from_value",
        editUom?.editState?.conversion_from_value
      );
      formik.setFieldValue(
        "conversion_to_value",
        editUom?.editState?.conversion_to_value
      );
      formik.setFieldValue(
        "status",
        editUom?.editState?.status === "ACTIVE" ? true : false
      );
    }
  }, [editUom]);

  return (
    <React.Fragment>
      <div className="container-fluid">
        <Row>
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation
              backIcon={true}
              displayText={"Back"}
            />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">
                  {editUom?.editAction ? "Edit UOM Ratio" : "Add UOM Ratio"}
                </div>
              </div>
              <Row>
                <Col xs={12} sm={12} md={5}>
                  <Form
                    noValidate
                    onSubmit={(e) => onClickSave(e)}
                    style={{ height: "75vh", position: "relative" }}
                  >
                    <Row>
                      <Col xs={12} className="mb-4">
                        <FormControl fullWidth variant="outlined">
                          <InputLabel id="demo-simple-select-label">
                            Major Classification
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="major_classification"
                            name="major_classification"
                            label="Major Classification"
                            className={`w-100 ${
                              formik.errors.major_classification &&
                              formik.touched.major_classification
                                ? "enError"
                                : ""
                            }`}
                            onChange={formik.handleChange}
                            value={formik.values.major_classification}
                            onBlur={formik.handleBlur}
                          >
                            <MenuItem value="" disabled selected>
                              Select Major Classification
                            </MenuItem>
                            {props?.majorClassification?.map((data, index) => {
                              return (
                                <MenuItem
                                  key={index}
                                  value={data.title.toUpperCase()}
                                  name={data.title}
                                >
                                  {data.title}
                                </MenuItem>
                              );
                            })}
                          </Select>
                          {formik.errors.major_classification &&
                          formik.touched.major_classification ? (
                            <div className="f10-500 text-danger mt-1">
                              {formik.errors.major_classification}
                            </div>
                          ) : null}
                        </FormControl>
                        {props.auth?.secondary_loader ? (
                          <div className="mt-2">
                            <Loader
                              type="Puff"
                              color="#00BFFF"
                              height={30}
                              width={30}
                            />
                          </div>
                        ) : null}
                      </Col>
                      <Col xs={6} sm={6} md={6}>
                        <FormControl fullWidth variant="outlined">
                          <InputLabel id="demo-simple-select-label">
                            Conversation From
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="conversion_from_short_code"
                            name="conversion_from_short_code"
                            label="Conversation From"
                            className={`w-100 ${
                              formik.errors.conversion_from_short_code &&
                              formik.touched.conversion_from_short_code
                                ? "enError"
                                : ""
                            }`}
                            onChange={formik.handleChange}
                            value={formik.values.conversion_from_short_code}
                            onBlur={formik.handleBlur}
                            disabled={
                              props?.conversationData?.length > 0 ? false : true
                            }
                          >
                            <MenuItem value="" disabled selected>
                              Select Conversation From
                            </MenuItem>
                            {props?.conversationData?.map((data, index) => {
                              return (
                                <MenuItem key={index} value={data.short_code}>
                                  {data.short_code}
                                </MenuItem>
                              );
                            })}
                          </Select>
                          {formik.errors.conversion_from_short_code &&
                          formik.touched.conversion_from_short_code ? (
                            <div className="f10-500 text-danger mt-1">
                              {formik.errors.conversion_from_short_code}
                            </div>
                          ) : null}
                        </FormControl>
                      </Col>
                      <Col xs={6} sm={6} md={6}>
                        <FormControl fullWidth variant="outlined">
                          <InputLabel id="demo-simple-select-label">
                            Conversation To
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="conversion_to_short_code"
                            name="conversion_to_short_code"
                            label="Conversation To"
                            className={`w-100 ${
                              formik.errors.conversion_to_short_code &&
                              formik.touched.conversion_to_short_code
                                ? "enError"
                                : ""
                            }`}
                            onChange={formik.handleChange}
                            value={formik.values.conversion_to_short_code}
                            onBlur={formik.handleBlur}
                            disabled={
                              props?.conversationData?.length > 0 ? false : true
                            }
                          >
                            <MenuItem value="" disabled selected>
                              Select Conversation To
                            </MenuItem>
                            {props?.conversationData?.map((data, index) => {
                              return (
                                <MenuItem
                                  key={index}
                                  value={data.short_code}
                                  name={data.short_code}
                                >
                                  {data.short_code}
                                </MenuItem>
                              );
                            })}
                          </Select>
                          {formik.errors.conversion_to_short_code &&
                          formik.touched.conversion_to_short_code ? (
                            <div className="f10-500 text-danger mt-1">
                              {formik.errors.conversion_to_short_code}
                            </div>
                          ) : null}
                        </FormControl>
                      </Col>
                      <Col xs={12} className="mt-2">
                        <h3 className="f18-700 my-4">Ratio of Conversion</h3>
                      </Col>
                      <Col xs={12} className="d-flex align-items-center">
                        <div style={{ width: "48%" }}>
                          <TextField
                            id="conversion_from_value"
                            label="Ratio value"
                            type="number"
                            variant="outlined"
                            className={`w-100 ${
                              formik.errors.conversion_from_value &&
                              formik.touched.conversion_from_value
                                ? "enError"
                                : ""
                            }`}
                            name="conversion_from_value"
                            onChange={formik.handleChange}
                            value={formik.values.conversion_from_value}
                            onBlur={formik.handleBlur}
                          />
                          {formik.errors.conversion_from_value &&
                          formik.touched.conversion_from_value ? (
                            <div className="f10-500 text-danger mt-1">
                              {formik.errors.conversion_from_value}
                            </div>
                          ) : null}
                        </div>
                        <div style={{ width: "5%" }} className="text-center">
                          :
                        </div>
                        <div style={{ width: "47%" }}>
                          <TextField
                            id="conversion_to_value"
                            label="Ratio value"
                            type="number"
                            variant="outlined"
                            className={`w-100 ${
                              formik.errors.conversion_to_value &&
                              formik.touched.conversion_to_value
                                ? "enError"
                                : ""
                            }`}
                            name="conversion_to_value"
                            onChange={formik.handleChange}
                            value={formik.values.conversion_to_value}
                            onBlur={formik.handleBlur}
                          />
                          {formik.errors.conversion_to_value &&
                          formik.touched.conversion_to_value ? (
                            <div className="f10-500 text-danger mt-1">
                              {formik.errors.conversion_to_value}
                            </div>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="mt-4">
                        <h3 className="f18-700 mb-2">Status</h3>
                        <div className="d-flex align-items-center">
                          <p className="f16-400 mr-4">
                            {formik.values?.status ? "Active" : "Inactive"}
                          </p>
                          <Switch
                            id="material-switch"
                            name="status"
                            onChange={onChangeStatus}
                            checked={formik.values?.status}
                            offColor="#212121"
                            onColor="#59F832"
                            offHandleColor="#FFFFFF"
                            onHandleColor="#FFFFFF"
                            handleDiameter={12}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            height={14}
                            width={27}
                            boxShadow="-2px 0px 5px #0000003B"
                            activeBoxShadow="-2px 0px 5px #0000003B"
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row
                      className="w-100"
                      style={{ position: "absolute", bottom: 0 }}
                    >
                      <Col xs={6} sm={6} md={5}>
                        <Button
                          variant="outline-secondary"
                          className="px-5 f18_500_HelveticaNeue w-75"
                          style={{
                            borderRadius: 8,
                            paddingTop: 12,
                            paddingBottom: 12,
                          }}
                          title="Cancel"
                          onClick={() =>
                            history.push(
                              "/superadmin/management-services/uom-ratio"
                            )
                          }
                        >
                          Cancel
                        </Button>
                      </Col>
                      <Col
                        xs={6}
                        sm={6}
                        md={5}
                        className="d-flex align-items-center"
                      >
                        <Button
                          variant="danger"
                          className="px-5 w-75 mr-3 f18_500_HelveticaNeue"
                          style={{
                            borderRadius: 8,
                            backgroundColor: "#EE3A23",
                            paddingTop: 12,
                            paddingBottom: 12,
                          }}
                          type="Submit"
                          title={
                            editUom?.editAction
                              ? "Update Uom Ratio"
                              : "Add Uom Ratio"
                          }
                        >
                          {editUom?.editAction ? "Update" : "Add"}
                        </Button>
                        {props.auth?.secondary_loader ? (
                          <Loader
                            type="Puff"
                            color="#00BFFF"
                            height={30}
                            width={30}
                          />
                        ) : null}
                      </Col>
                    </Row>
                  </Form>
                </Col>
              </Row>
            </div>
          </div>
        </Row>
      </div>
    </React.Fragment>
  );
};

SuperAdminAddUomRatio.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  clear_all_errors: PropTypes.func.isRequired,
  admin_add_uom_ratio: PropTypes.func.isRequired,
  admin_update_uom_ratio: PropTypes.func.isRequired,
  admin_get_all_ratio_conversation: PropTypes.func.isRequired,
  majorClassification: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  majorClassification: state?.category?.major_classification,
  conversationData: state?.uomRatioManagement?.getAllConversation,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  admin_add_uom_ratio,
  admin_update_uom_ratio,
  admin_get_all_ratio_conversation,
})(withRouter(SuperAdminAddUomRatio));
